import React, { Component } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import classes from "./modeofinterview.module.css";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import { withRouter } from "react-router-dom";

export class Modeofinterview extends Component {
  state = {
    checkedvalue: "30",
    errorMsg: null,
    userType: localStorage.getItem("userType"),
    ShowModalOpen: false,
  };
  // selectModeofInterview = (e) => {
  //   var checkboxes = e.target.value;
  //   this.setState({ errorMsg: null, checkedvalue: checkboxes });
  //   //this.state.checkedvalue=checkboxes;
  // };
  selectModeofInterview = (modeVal, timeVal) => {
    // if(modeVal !== null) {
    var checkboxes = modeVal;
    this.setState({ errorMsg: null, checkedvalue: checkboxes });
    // }
    // if(timeVal!==null) {
    var checkboxes1 = timeVal;
    this.setState({
      durationErrorMsg: null,
      checkedduration: this.props.duration === "60" ? "60" : checkboxes1,
    });

    console.log("After Set:", localStorage.getItem("selectedDuration"));
    // }
  };
  // proceed = () => {
  //   if (this.state.checkedvalue !== null) {
  //     this.props.selectModeofInterview(
  //       this.state.checkedvalue,
  //       this.state.checkedduration
  //     );
  //   } else {
  //     this.setState({ errorMsg: "Please select an option" });
  //   }
  // };
  proceed = () => {
    if (this.state.checkedvalue !== null) {
      const selectedValues = {
        mode: this.state.checkedvalue,
        duration: this.state.checkedduration,
      };

      this.props.history.push({
        pathname: "/interview/createNew",
        state: { selectedValues },
      });
    } else {
      this.setState({ errorMsg: "Please select an option" });
    }
  };

  componentDidMount = () => {
    this.setState((Prev) => ({ ...Prev, ShowModalOpen: true }));
  };
  ShowModalClose = () => {
    console.log("Closing modal");
    this.setState((Prev) => ({ ...Prev, ShowModalOpen: false }));
  };

  render() {
    localStorage.setItem("selectedDuration", this.state.checkedvalue);
    return (
      <Modal centered show={this.props.show}>
        {this.state.userType == 0 ? (
          <>
            <Modal.Header>
              <Modal.Title
                style={{ textAlign: "center", padding: "0 0 0 6%" }}
                id="contained-modal-title-vcenter"
              >
                Select Session Duration
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12}>
                  <div className={classes.selectradio}>
                    <label
                      className={classes.profilePopUp}
                      style={{ margin: "0% 4% 0% 1%" }}
                    >
                      <input
                        type="radio"
                        name="duration"
                        value="30"
                        checked={this.state.checkedvalue === "30"}
                        onChange={(e) =>
                          this.setState({
                            checkedvalue: e.target.value,
                          })
                        }
                      />
                      &nbsp; &nbsp;30 Min.
                      <span className={classes.checkmark}></span>
                    </label>
                    &nbsp; &nbsp;
                    <label className={classes.profilePopUp}>
                      <input
                        type="radio"
                        name="duration"
                        value="60"
                        checked={this.state.checkedvalue === "60"}
                        onChange={(e) =>
                          this.setState({
                            checkedvalue: e.target.value,
                          })
                        }
                      />
                      &nbsp; &nbsp;1 Hour
                      <span className={classes.checkmark}></span>
                    </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12} style={{ textAlign: "center", color: "red" }}>
                  {this.state.durationErrorMsg !== null
                    ? this.state.durationErrorMsg
                    : null}
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className={classes.selectradio}>
              <div className={classes.selectbutton} style={{ display: "flex" }}>
                {/* <Button
                    onClick={() => this.ShowModalClose()}
                    variant="outline-warning"
                    className={classes.closeandproceddbutton1}
                  >
                    Close
                  </Button> */}
                <Button
                  variant="warning"
                  onClick={() => {
                    this.proceed();
                    this.props.history.push("/interview/createNew");
                  }}
                  className={classes.closeandproceddbutton2}
                >
                  Proceed
                </Button>
              </div>
            </Modal.Footer>
          </>
        ) : (
          <Modal.Body>
            <Row>
              <Col lg={12}>
                <div className={classes.selectradio}>
                  <label className={classes.profilePopUp}>
                    <input
                      type="radio"
                      name="gender"
                      onChange={this.selectModeofInterview.bind(this)}
                      value="Telephonic"
                    />
                    &nbsp; &nbsp;Telephonic
                    <span className={classes.checkmark}></span>
                  </label>
                  &nbsp; &nbsp;
                  <label className={classes.profilePopUp}>
                    <input
                      type="radio"
                      name="gender"
                      onChange={this.selectModeofInterview.bind(this)}
                      value="Video"
                    />
                    &nbsp; &nbsp;Video
                    <span className={classes.checkmark}></span>
                  </label>
                  &nbsp; &nbsp;
                  <label className={classes.profilePopUp}>
                    <input
                      type="radio"
                      name="gender"
                      onChange={this.selectModeofInterview.bind(this)}
                      value="Face to Face"
                    />
                    &nbsp; &nbsp;Face to Face
                    <span className={classes.checkmark}></span>
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12} style={{ textAlign: "center", color: "red" }}>
                {this.state.errorMsg !== null ? this.state.errorMsg : null}
              </Col>
            </Row>
          </Modal.Body>
        )}
      </Modal>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    telephonic: state.employeeReducer.telephonic,
    vedio: state.employeeReducer.vedio,
    faceToFace: state.employeeReducer.faceToFace,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getScheduleInterviwerList: (page, data) =>
      dispatch(actionTypes.getScheduleInterviwerList(page, data)),
  };
};
// export default connect(mapStateToProps, mapDispatchToProps)(Modeofinterview);
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Modeofinterview)
);
